module.exports = __webpack_public_path__ + "console/img/京东.c491a431.jpg";